import { createFileRoute } from "@tanstack/react-router";
import { requireRoutePermission } from "../../route-authorization";
import { RoutedDashboardPage } from "../../dashboard-page-context";

export const Route = createFileRoute("/app/account-mapping")({
  beforeLoad: () => requireRoutePermission("account_mapping.view"),
  component: RoutedDashboardPage,
});
